import {TableCell, TableSortLabel} from "@mui/material";

const SortableTableCell = ({field, sortBy, sortDirection, onSort, sx, children, ...rest}) => {
  const isActive = sortBy === field;
  const direction = isActive ? sortDirection.toLowerCase() : "asc";

  const handleClick = () => {
    if (!onSort) return;
    if (isActive) {
      onSort(field, sortDirection === "ASC" ? "DESC" : "ASC");
    } else {
      onSort(field, "ASC");
    }
  };

  return (
      <TableCell sx={sx} sortDirection={isActive ? direction : false} {...rest}>
        <TableSortLabel
            active={isActive}
            direction={direction}
            onClick={handleClick}
            sx={{
              "& .MuiTableSortLabel-icon": {marginRight: "2px", marginLeft: "2px"},
              "&:hover": {color: "inherit"},
              "&.Mui-active": {color: "inherit"},
            }}
        >
          {children}
        </TableSortLabel>
      </TableCell>
  );
};

export default SortableTableCell;
